import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';
import type { FontSize } from '../schema/FontSize';

export const setFontSize = mutatorAction('setFontSize', (fontSize: FontSize) => {
    store.fontSize = fontSize;
});
